import React from 'react'

import { AuthUserContext, UserProfileContext, ModulesContext } from '../Session'
import { Navigate, useLocation } from 'react-router-dom'
import UserLayout from '../../layouts/UserLayout'
import AuthLayout from '../../layouts/AuthLayout'
import AdminLayout from '../../layouts/AdminLayout'
import CashierLayout from '../../layouts/CashierLayout'
import { CustomerdataContext } from '../Session/context'

const WhereToGo = () => {
  const location = useLocation()

  return (
    <div>
      <AuthUserContext.Consumer>
        {(authUser) => (
          <CustomerdataContext.Consumer>
            {(customerdata) => (
              <ModulesContext.Consumer>
                {(modules) => (
                  <UserProfileContext.Consumer>
                    {(profile) => {
                      if (authUser === undefined) {
                        // Session still being restored. Rendering nothing for a moment
                        // beats redirecting to the login page and losing the requested
                        // URL, which is what broke every deep link into the app.
                        return null
                      }
                      if (authUser) {
                        if (profile.role === 'ADMIN') {
                          return (
                            <AdminLayout
                              user={authUser}
                              profile={profile}
                              modules={modules}
                              customerdata={customerdata}
                              customerId={
                                profile.customerIds
                                  ? profile.customerIds[0]
                                  : null
                              }
                            />
                          )
                        } else if (profile.role === 'CASHIER') {
                          return (
                            <CashierLayout
                              user={authUser}
                              profile={profile}
                              modules={modules}
                              customerdata={customerdata}
                            />
                          )
                        } else if (profile.role === 'USER') {
                          return (
                            <UserLayout
                              user={authUser}
                              profile={profile}
                            />
                          )
                        } else if (profile.role === 'PARTNER') {
                          return (
                            <CashierLayout
                              user={authUser}
                              profile={profile}
                              modules={modules}
                              customerdata={customerdata}
                            />
                          )
                        } else if (profile.role === 'COOPERATIVE') {
                          return (
                            <CashierLayout
                              user={authUser}
                              profile={profile}
                              modules={modules}
                              customerdata={customerdata}
                            />
                          )
                        }
                      } else if (location.pathname === '/auth/login') {
                        return <AuthLayout user={authUser} />
                      } else if (location.pathname === '/auth/forget') {
                        return (
                          <AuthLayout
                            user={authUser}
                            forget={true}
                          />
                        )
                      } else {
                        return <Navigate to='/auth/login' replace />
                      }
                    }}
                  </UserProfileContext.Consumer>
                )}
              </ModulesContext.Consumer>
            )}
          </CustomerdataContext.Consumer>
        )}
      </AuthUserContext.Consumer>
    </div>
  )
}

export { WhereToGo }
